export default {
    computed: {

        newsletterData() {
            return this.$store.state.subscription.newsletterData
        },

        subscriptionData() {
            return this.$store.state.subscription.subscriptionData
        },

        formSelectChoices() {
            return this.$store.state.subscription.formSelectChoices
        },

        newsletterIsLoaded() {
            return this.$store.state.subscription.newsletterIsLoaded
        },

        subscriptionFinishedSuccessful() {
            return this.$store.state.subscription.subscriptionFinishedSuccessful
        },

        subscriberToken: {
            get: function () {
                return this.$store.state.subscription.subscriberToken
            },
            set: function (value) {
                this.$store.commit('subscription/setSubscriberToken', value)
            }
        },

        unsubscribe: {
            get: function () {
                return this.$store.state.subscription.unsubscribe
            },
            set: function (value) {
                this.$store.commit('subscription/setUnsubscribe', value)
            }
        },

        newsletterProfiles: {
            get() {
                return this.newsletterData?.activeProfiles
            }
        },

        editor: {
            get() {
                return this.newsletterData?.editor
            }
        }
    },

    methods: {
        /////////////////////////////////////////////////
        //Mutations
        /////////////////////////////////////////////////

        setSubscriptionProp(prop, value, path = null) {
            this.$store.commit('subscription/setSubscriptionProp', {prop, value, path})
        },

        setNewsletterData(newsletter) {
            this.$store.commit('subscription/setNewsletterData', newsletter)
        },

        setNewsletterIsLoaded(loaded) {
            this.$store.commit('subscription/setNewsletterIsLoaded', loaded)
        },

        discardNewsletterData() {
            this.$store.commit('subscription/discardNewsletterData')
        },

        discardSubscriptionData() {
            this.$store.commit('subscription/discardSubscriptionData')
        },

        resetFeeSelection() {
            return this.$store.commit('subscription/resetFeeSelection')
        },


        /////////////////////////////////////////////////
        //Actions
        /////////////////////////////////////////////////
        fetchNewsletterData(newsletterId, loadRemainingFreePlacesOnly = false) {
            return this.$store.dispatch('subscription/fetchNewsletterData', {newsletterId, loadRemainingFreePlacesOnly})
        },

        sendSubscription(fundraiser = null) {
            return this.$store.dispatch('subscription/sendSubscription', fundraiser)
        },

        fetchDonorInformation(donorHint) {
            return this.$store.dispatch('subscription/fetchDonorInformation', donorHint)
        }
    }
}
